module.exports = __webpack_public_path__ + "img/choose-topic.104223fa.svg";